import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Horizontal, Vertical } from '#src/atoms/layout/flex/index.tsx';
import { BodyL, BrandXS } from '#src/atoms/typography/index.tsx';
import { positionsMap } from '#src/components/HowToPlay/CreateATeam/constants.ts';
import { PositionIcon } from '#src/components/lineup/PositionIcon/index.tsx';

const Root = styled(Vertical)`
  align-items: center;
  justify-content: center;
  gap: var(--double-unit);
  background-color: var(--c-nd-50);
  padding: var(--double-unit);
  border-radius: var(--unit);
`;

const StyledPositionIcon = styled(PositionIcon)`
  color: var(--c-blue-400);
`;

const PositionsWrapper = styled(Horizontal).attrs({ center: true })`
  flex-wrap: wrap;
`;
export const Subtitle = () => {
  return (
    <Root>
      <BodyL>
        <FormattedMessage defaultMessage="Sorare competitions require 5 player lineups." />
      </BodyL>
      <Vertical center>
        <Horizontal>
          {positionsMap.slice(0, -1).map((_, index) => {
            const position = positionsMap[index];
            return (
              <PositionsWrapper key={position.position}>
                <StyledPositionIcon
                  position={positionsMap[index].position}
                  className={classnames({
                    purple: true,
                  })}
                />
                <BrandXS uppercase>{position.position}</BrandXS>
              </PositionsWrapper>
            );
          })}
        </Horizontal>
        <Horizontal>
          <StyledPositionIcon
            position={positionsMap[positionsMap.length - 1].position}
            className={classnames({
              purple: true,
            })}
          />
          <BrandXS uppercase>
            <FormattedMessage defaultMessage="One 'Extra' player (either a Defender, Midfielder, or Forward)" />
          </BrandXS>
        </Horizontal>
      </Vertical>
    </Root>
  );
};
